import { Components, Theme } from '@mui/material/styles';

export default function MuiAlert(theme: Theme): Components['MuiAlert'] {
  return {
    styleOverrides: {
      root: {
        border: '1px solid',
      },
    },
    variants: [
      {
        props: { severity: 'info' },
        style: {
          backgroundColor: theme.palette.informationBackground.main,
          color: theme.palette.informationText.main,
          borderColor: theme.palette.informationBorder.main,
        },
      },
      {
        props: { severity: 'success' },
        style: {
          backgroundColor: theme.palette.successBackground.main,
          color: theme.palette.successText.main,
          borderColor: theme.palette.successBorder.main,
        },
      },
      {
        props: { severity: 'warning' },
        style: {
          backgroundColor: theme.palette.warningBackground.main,
          color: theme.palette.warningText.main,
          borderColor: theme.palette.warningBorder.main,
        },
      },
      {
        props: { severity: 'error' },
        style: {
          backgroundColor: theme.palette.errorBackground.main,
          color: theme.palette.errorText.main,
          borderColor: theme.palette.errorBorder.main,
        },
      },
    ],
  };
}
